import React from 'react';
import { useParams } from 'react-router-dom';
import BestwayTransactionHeader from './header/BestwayTransactionHeader';
import BestwayTransactionLines from './lines/BestwayTransactionLines';

export default function BestwayTransaction() {
    let params = useParams();
    let depotId = params.depot;
    let transactionId = params.transactionId;

    return (
        <>
            <div className={'page-header'}>
                <div className={'content'}>
                    <div className={'page-header-container flex'}>
                        <BestwayTransactionHeader depotId={depotId} transactionId={transactionId} />
                    </div>
                </div>
                <div className={'content order-lines'}>
                    <BestwayTransactionLines depotId={depotId} transactionId={transactionId} />
                </div>
            </div>
        </>
    );
}
